'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { navItems } from './nav';

export default function DesktopNav({ onDark = false }: { onDark?: boolean }) {
    const pathname = usePathname();

    return (
        <nav className="hidden items-center gap-8 text-sm font-medium lg:flex">
            {navItems.map((item) => {
                const isActive = pathname === item.href;
                return (
                    <Link
                        key={item.href}
                        href={item.href}
                        className={`relative transition-colors ${
                            isActive
                                ? onDark
                                    ? 'text-white font-semibold'
                                    : 'text-[#257676] font-semibold dark:text-[#4dbdbd]'
                                : onDark
                                    ? 'text-white/85 hover:text-white'
                                    : 'text-slate-700 hover:text-[#257676] dark:text-slate-200 dark:hover:text-[#4dbdbd]'
                        }`}
                    >
                        {item.label}
                        {isActive && (
                            <span
                                className={`absolute -bottom-1 left-0 right-0 h-0.5 rounded-full ${
                                    onDark ? 'bg-white' : 'bg-[#257676] dark:bg-[#4dbdbd]'
                                }`}
                            />
                        )}
                    </Link>
                );
            })}
        </nav>
    );
}
